import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  title: 'Início Rápido',
  description: 'Siga este guia para chegar ao lançamento o mais rápido possível',
  steps: {
    [ONBOARDING_GUIDE_STEPS.Notifications]: 'Preferências de notificação',
    [ONBOARDING_GUIDE_STEPS.OpenTimesAndLocation]: 'Horários e localização',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Identidade do restaurante',
    [ONBOARDING_GUIDE_STEPS.OrderSettings]: 'Definições de pedidos',
    [ONBOARDING_GUIDE_STEPS.Menu]: 'Configuração do menu',
    [ONBOARDING_GUIDE_STEPS.Marketing]: 'Marketing e Fidelização',
    [ONBOARDING_GUIDE_STEPS.MyStore]: 'A Minha Loja',
    [ONBOARDING_GUIDE_STEPS.GoLive]: 'Lançar',
    [ONBOARDING_GUIDE_STEPS.Complete]: 'Concluído',
  },
  toasts: {
    failed_to_load_onboarding: 'Falha ao carregar os passos de integração',
  },
};
